const dlPush = (data) => {
  if (process.browser) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ...data
    });
  }
}

export default dlPush